module.exports = __webpack_public_path__ + "static/media/smallville.895314b9.jpg";